import * as React from "react";
import "styles/verify-code.scss";
import { maskEmail } from "../../../utils/Helpers";
import PortalPanel from "../../shared/PortalPanel";
import OtpInput from "./OtpInput";

const VerifyCode: React.FC<{
  email: string;
  showErrors: boolean;
  imagePath?: string;
  onGoBack: () => void;
  onSendCode: () => void;
  onVerifyCode: (code: string) => void;
  secondsRemainingToAllowCodeResend: number;
}> = ({
  email,
  showErrors,
  imagePath,
  onGoBack,
  onSendCode,
  onVerifyCode,
  secondsRemainingToAllowCodeResend,
}) => {
  // For Segmented Auto-Moving Password Code

  const [code, setCode] = React.useState<string>("");

  React.useEffect(() => {
    onSendCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // END

  return (
    <>
      <PortalPanel
        image={imagePath}
        title={"Confirm your account"}
        subtitle={`Enter the code you received at ${maskEmail(email)}.`}
        onGoBack={onGoBack}
        primaryButton={{
          text: "Confirm account",
          action: () => onVerifyCode(code),
          isDisabled: code.length !== 6,
        }}
        secondaryButton={{
          text: `Resend email ${
            secondsRemainingToAllowCodeResend > 0
              ? `in ${secondsRemainingToAllowCodeResend}s`
              : ""
          }`,
          action: onSendCode,
          isDisabled: secondsRemainingToAllowCodeResend > 0,
        }}
      >
        <OtpInput code={code} setCode={setCode} />
        {showErrors && (
          <div className="text-danger">Please enter a valid code.</div>
        )}
      </PortalPanel>
    </>
  );
};

export default VerifyCode;
